import { isCopyToClipboardSupported, copyToClipboard } from '@/utils/vuex';
export default {
  name: 'CustomTextFieldClipboard',
  props: {
    readOnly: {
      type: Boolean,
      default: true
    },
    dataCy: {
      type: String,
      default: null
    }
  },
  data() {
    return {};
  },
  computed: {
    isCopySupported() {
      return isCopyToClipboardSupported();
    }
  },
  methods: {
    ripple() {
      const $el = this.$refs.element.$el;
      const ev = new Event('mousedown');
      const offset = $el.getBoundingClientRect();
      ev.clientX = offset.left + offset.width / 2;
      ev.clientY = offset.top + offset.height / 2;
      $el.dispatchEvent(ev);
      this.$nextTick(() => {
        $el.dispatchEvent(new Event('mouseup'));
      });
    },
    selectInputValue() {
      this.$nextTick(() => {
        this.$refs.element.$refs.input.select();
      });
    },
    handleClick(event) {
      event.stopPropagation();
      this.selectInputValue();
      copyToClipboard(this.$attrs.value);
    },
    handleClickAppend(event) {
      event.stopPropagation();
      this.ripple();
      this.selectInputValue();
      copyToClipboard(this.$attrs.value);
    }
  }
};